export const LoadingState = {
  unset: "unset",
  loading: "loading",
  loaded: "loaded",
  failed: "failed",
};
